import Backbone from "backbone";
import readlangClient from "readlangClient";
import * as dateUtils from "shared/dateUtils";
import perDayAverage from "shared/perDayAverage";
import * as utils from "shared/utils";
import * as _ from "underscore";
import XRegExp from "xregexp";

export default class UserWordModel extends Backbone.Model {
  // @ts-ignore
  get urlRoot() {
    return "/api/userWord";
  }

  // @ts-ignore
  get idAttribute() {
    return "_id";
  }

  constructor(attributes?: Record<string, any>) {
    super(attributes);
  }

  defaults() {
    return {
      alternativeTranslations: [],
      alternativeWords: [], // synonyms
      contexts: [],
    };
  }

  lastSeen() {
    if (this.has("nextDate")) {
      const lastSeenDate = new Date(
        new Date(dateUtils.parse(this.get("nextDate"))).getTime() -
          parseInt(this.get("interval"), 10)
      );

      return lastSeenDate;
    } else {
      return null;
    }
  }

  perDayAverage(date) {
    return perDayAverage(this.attributes, date);
  }

  perDayAverageChange(date) {
    return (
      perDayAverage(this.attributes, date) -
      perDayAverage((this as any)._previousAttributes, date)
    );
  }

  isPhrase() {
    return utils.notWordRegExp().test(this.get("word"));
  }

  async recall(options) {
    await readlangClient.request(
      "POST",
      "/api/userWord/" + this.id + "/recall",
      _.pick(options, "recallEase", "strength")
    );
    // just for local use
    this.set("recalledThisSession", true);
  }

  formatTranslations() {
    return [
      this.get("translation"),
      ...this.get("alternativeTranslations"),
    ].join(" / ");
  }
}

export const formattedContextHtml = (contextText, word) => {
  const result = contextText.replace(
    XRegExp("(\\P{L}|^)(" + utils.regexpEscape(word) + ")(\\P{L}|$)", "i"),
    "$1<strong>$2</strong>$3"
  );
  return result;
};
